import { Reducer } from 'redux';

// Types
import { FareBonusState, FareBonusTypes } from './types';

const INITIAL_STATE: FareBonusState = {
  fareBonusList: [],
  fareBonusData: null,
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<FareBonusState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST FARE BONUS
    case FareBonusTypes.LIST_FARE_BONUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareBonusList: INITIAL_STATE.fareBonusList,
      };
    case FareBonusTypes.LIST_FARE_BONUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareBonusList: action.payload.fareBonusList,
        totalCount: action.payload.totalCount,
      };
    case FareBonusTypes.LIST_FARE_BONUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareBonusList: INITIAL_STATE.fareBonusList,
      };

    // CASES GET FARE BONUS
    case FareBonusTypes.GET_FARE_BONUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareBonusData: INITIAL_STATE.fareBonusData,
      };
    case FareBonusTypes.GET_FARE_BONUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareBonusData: action.payload.fareBonusData,
      };
    case FareBonusTypes.GET_FARE_BONUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareBonusData: INITIAL_STATE.fareBonusData,
      };

    // CASES FILTER FARE BONUS
    case FareBonusTypes.FILTER_FARE_BONUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareBonusList: INITIAL_STATE.fareBonusList,
      };
    case FareBonusTypes.FILTER_FARE_BONUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareBonusList: action.payload.fareBonusList,
      };
    case FareBonusTypes.FILTER_FARE_BONUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareBonusList: INITIAL_STATE.fareBonusList,
      };

    // CASES CREATE FARE BONUS
    case FareBonusTypes.CREATE_FARE_BONUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareBonusData: INITIAL_STATE.fareBonusData,
      };
    case FareBonusTypes.CREATE_FARE_BONUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareBonusData: action.payload.fareBonusData,
      };
    case FareBonusTypes.CREATE_FARE_BONUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareBonusData: INITIAL_STATE.fareBonusData,
      };

    // CASES UPDATE FARE BONUS
    case FareBonusTypes.UPDATE_FARE_BONUS_REQUEST:
      return { ...state, loading: true, error: false };

    case FareBonusTypes.UPDATE_FARE_BONUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareBonusData: action.payload.fareBonusData,
      };
    case FareBonusTypes.UPDATE_FARE_BONUS_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE FARE BONUS
    case FareBonusTypes.DELETE_FARE_BONUS_REQUEST:
      return { ...state, loading: true, error: false };

    case FareBonusTypes.DELETE_FARE_BONUS_SUCCESS:
      return { ...state, loading: false, error: false };

    case FareBonusTypes.DELETE_FARE_BONUS_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
